module.exports = __webpack_public_path__ + "img/potential_1_star_5.e86d450d.png";